<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
            <!-- <router-link :to="{path:'/admin'}">Dashboard</router-link> -->
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; PT. BUANA CENTRA KARYA
        <!-- <i class="fa fa-heart heart"></i> by
        <a href="https://binarcode.com" target="_blank">BinarCode</a>.
        Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" target="_blank">Creative Tim</a>. -->
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style lang='scss' scoped>
  @import "@/assets/scss/light-bootstrap-dashboard.scss";
</style>
